{
    "filters": "Filter",
    "filterName": "Filter Name",
    "filtersCreateComment": "Please choose a new name for your filter and then click create",
    "filtersCreateTitle": "Create New Filter",
    "filtersNameInvalid": "Filter names must begin with a letter and may only contain letters, numbers and the underscore character",
    "filtersNameDuplicate": "An attribute or filter with this name already exists, please choose a different name",
    "filtersCopyTitle": "Copy Existing Filter",
    "filtersCopyComment": "Please enter a new name for your filter and select a filter you would like to duplicate, then click copy",
    "entityReferenceError": "Cannot delete as entity currently in use by another attribute or filter",
    "filtersNotSelected": "Please select at least one record",
    "filtersSelected": "Please select no more than one record",
    "checkingFilterSave": "Are you sure you would like to save this filter?",
    "areYouSure": "Are you sure?",
    "filtersDeleted": "The filters were successfully deleted",
    "checkingFilterDeletion": "Are you sure you would like to delete this filter?",
    "checkingFiltersDeletion": "Would you like to delete the selected filters?",
    "checkingFiltersDeletionInuse": "One or more entities are in use elsewhere. They will be deleted which may cause the system to become unstable.",
    "cancel": "Cancel",
    "ok": "Ok",
    "thanks": "Thanks!",
    "delete": "Delete",
    "filterSaved": "The filter was successfully saved",
    "filterDeleted": "The filter was successfully deleted",
    "filterLocked": "Filter succesfully locked",
    "dataSourceLocked": "Data Source succesfully locked",
    "filterUnlocked": "Filter succesfully unlocked",
    "dataSourceUnlocked": "Data Source succesfully unlocked",
    "whereUsed": "Where Used",
    "systems": "Systems",
    "shortName": "Short Name",
    "type": "Type",
    "successfulFilterRollback": "Filter has successfully been rolled back",
    "rollbackError": "Rollback Failed: ",
    "filterArguments": "Filter Arguments",
    "dataSource": "Data Source",
    "argument": "Argument ",
    "serverSaveError": "Filter with the same name already exists",
    "reservedKeywordsError": "The short name entered is a reserved keyword and cannot be used",
    "deleteError": "One or more entities are currently open for editing by you and must be closed before they can be deleted",
    "filterOpenError": "Please close all open filter tabs and try again.",
    "allFiltersLocked": "All filters succesfully locked",
    "allFiltersUnlocked": "All filters succesfully unlocked",
    "allDataSourcesLocked": "All Data Sources succesfully locked",
    "allDataSourcesUnlocked": "All Data Sources succesfully unlocked",
    "filterAlertTitle": "Filters",
    "columns": "Columns",
    "columnVisibility": "Column Visibility"
}